import styled from 'styled-components';

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;

    h2 {
        font-size: 24px;
        font-weight: 600;
        color: #212b36;
    }
`;

export const StatusCell = styled.div<{ status?: string }>`
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    padding: 8px 12px;
    border-radius: 6px;
    transition: background-color 0.2s ease;
    color: ${({status}) => {
        if (status === 'TO_BE_SOLVED') return '#FF4842';
        if (status === 'IN_PROGRESS') return '#FFAA00';
        if (status === 'RESOLVED') return '#54D62C';
        return '#212b36';
    }};

    &:hover {
        background-color: #F4F6F8;
    }

    &::before {
        content: '';
        display: inline-block;
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: ${({status}) => {
            if (status === 'TO_BE_SOLVED') return '#FF4842';
            if (status === 'IN_PROGRESS') return '#FFAA00';
            if (status === 'RESOLVED') return '#54D62C';
            return '#919EAB';
        }};
    }
`;